import { createAsyncThunk } from "@reduxjs/toolkit";
import { getKybWalletWishListApi, getUserDocListApi, getUserKybAffiliantedApi, getAccDetailsApi, getCinGSTINDetailsApi, getChecklistApi, getDirectorInfoMetadataApi, getBankDetailsApi, getAllDocumentsApi, getKycCycleHistoryApi } from "../../utils/api";
import toast from "react-hot-toast";

export const actionGetUserDocList = createAsyncThunk(
  "kybOnboarding/getUserDocList",
  async (params = {}, { rejectWithValue, getState }) => {
    try {
      const { id, kycCycleId } = typeof params === 'object' ? params : { id: params, kycCycleId: null };
      const res = await getUserDocListApi(id, kycCycleId);
      if(res?.status){
        toast.success("User documents fetched successfully");
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetUserKybAffiliantedList = createAsyncThunk(
  "kybOnboarding/getUserKybAffiliantedList",
  async (params = {}, { rejectWithValue }) => {
    try {
      // params: { id, type, kycCycleId }
      const res = await getUserKybAffiliantedApi(params.id, params.type, params.kycCycleId);
      if(res?.status){
        toast.success("User documents fetched successfully");
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetUserKybWalletWishList = createAsyncThunk(
  "kybOnboarding/getUserKybWalletWishList",
  async (params = {}, { rejectWithValue }) => {
    try {
      // params can be { email } / { account_id } etc depending on your API signature
      const res = await getKybWalletWishListApi(params.id, params.type);
      if(res?.status){
        toast.success("User documents fetched successfully");
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

// Replace manual KYB_ACC_DETAILS_* with createAsyncThunk version
export const actionGetAccDetails = createAsyncThunk(
  "kybOnboarding/getAccDetails",
  async (params = {}, { rejectWithValue, dispatch }) => {
    try {
      const res = await getAccDetailsApi(params);
      const data = res?.data || res;
      if (res?.status) {
        toast.success("Account details fetched successfully");
      }
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetCinGSTINDetails = createAsyncThunk(
  "kybOnboarding/getCinGSTINDetails",
  async (accountId, { rejectWithValue }) => {
    try {
      const res = await getCinGSTINDetailsApi(accountId);
      if (res?.status) {
        toast.success("CIN/GSTIN details fetched successfully");
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetBankDetails = createAsyncThunk(
  "kybOnboarding/getBankDetails",
  async (accountId, { rejectWithValue }) => {
    try {
      const res = await getBankDetailsApi(accountId);
      if (res?.status) {
        toast.success("Bank details fetched successfully");
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetChecklist = createAsyncThunk(
  "kybOnboarding/getChecklist",
  async (params, { rejectWithValue }) => {
    try {
      const { accountId, kycCycleId } = typeof params === 'object' && params.accountId ? params : { accountId: params, kycCycleId: null };
      const res = await getChecklistApi(accountId, kycCycleId);
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetDirectorInfoMetadata = createAsyncThunk(
  "kybOnboarding/getDirectorInfoMetadata",
  async (accountId, { rejectWithValue }) => {
    try {
      const res = await getDirectorInfoMetadataApi(accountId);
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetAllDocumentsDownloadUrl = createAsyncThunk(
  "kybOnboarding/getAllDocumentsDownloadUrl",
  async (params, { rejectWithValue }) => {
    try {
      const { accountId, kycCycleId } = typeof params === 'object' && params.accountId ? params : { accountId: params, kycCycleId: null };
      const res = await getAllDocumentsApi(accountId, kycCycleId);
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Request failed");
    }
  }
);

export const actionGetKycCycleHistory = createAsyncThunk(
  "kybOnboarding/getKycCycleHistory",
  async (accountId, { rejectWithValue }) => {
    try {
      const res = await getKycCycleHistoryApi(accountId);
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err?.message ?? "Failed to fetch KYC cycle history");
    }
  }
);
